import { createContext, useContext } from "react"
import { IWorkItemManager } from "../types";

export const WorkItemManagerContext = createContext({} as IWorkItemManager);

export function useWorkItemManager() {
    return useContext(WorkItemManagerContext);
}